import { render } from "./ModuleMenuV2.vue?vue&type=template&id=6e24bd91&scoped=true"
import script from "./ModuleMenuV2.vue?vue&type=script&lang=js"
export * from "./ModuleMenuV2.vue?vue&type=script&lang=js"

import "./ModuleMenuV2.vue?vue&type=style&index=0&id=6e24bd91&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e24bd91"]])

export default __exports__